import React from 'react';
import ContainerTemplate from '../../widgets/template/Container';
import HerramientasView from './HerramientasView';
import * as ROUTES from '../../router/Routes';

const HerramientasModule = () => {
  return (
    <ContainerTemplate active={ROUTES.herramientas} routes={[]}>
      <HerramientasView />
    </ContainerTemplate>
  );
};

export default HerramientasModule;
